'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = _interopDefault(require('react'));

var Styled = _interopDefault(require('styled-components'));

var PropTypes = _interopDefault(require('prop-types'));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var StyledSpan = Styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: ", ";\n\twidth: ", ";\n\talign-items: center;\n\t> svg {\n\t\tpath {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\t&:hover\t{ \n\t\t> svg {\n\t\t\tpath {\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref) {
  var size = _ref.size;
  return size + 'px';
}, function (_ref2) {
  var size = _ref2.size;
  return size + 'px';
}, function (_ref3) {
  var color = _ref3.color,
      overrideColor = _ref3.overrideColor;
  return overrideColor && color;
}, function (_ref4) {
  var color = _ref4.color,
      hoverColor = _ref4.hoverColor;
  return hoverColor ? hoverColor : color;
});

var BaseIcon = function BaseIcon(_ref5) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? SIZE.MEDIUM : _ref5$size,
      _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? '#4C4C58' : _ref5$color,
      overrideColor = _ref5.overrideColor,
      hoverColor = _ref5.hoverColor;

  var getSize = function getSize(size) {
    switch (size) {
      case SIZE.SMALL:
        return 16;

      case SIZE.MEDIUM:
        return 20;

      case SIZE.LARGE:
        return 24;
    }
  };

  return /*#__PURE__*/React.createElement(StyledSpan, {
    size: getSize(size),
    color: color,
    overrideColor: overrideColor,
    hoverColor: hoverColor
  }, children);
};

var iconPropTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(Object.values(SIZE)),
  color: PropTypes.string,
  overrideColor: PropTypes.bool,
  hoverColor: PropTypes.string
};
var iconDefaultProps = {
  size: SIZE.MEDIUM,
  color: '#4C4C58',
  overrideColor: true,
  hoverColor: '#4C4C58'
};
BaseIcon.SIZE = SIZE;
BaseIcon.propTypes = iconPropTypes;
BaseIcon.defaultProps = iconPropTypes;

var PrintIcon = function PrintIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79995 9.80005C5.46858 9.80005 5.19995 10.0687 5.19995 10.4C5.19995 10.7314 5.46858 11 5.79995 11H7.39996C7.73133 11 7.99996 10.7314 7.99996 10.4C7.99996 10.0687 7.73133 9.80005 7.39996 9.80005H5.79995Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19998 14.4C8.8686 14.4 8.59998 14.6687 8.59998 15C8.59998 15.3314 8.8686 15.6 9.19998 15.6H14.8C15.1313 15.6 15.4 15.3314 15.4 15C15.4 14.6687 15.1313 14.4 14.8 14.4H9.19998Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59998 17.2C8.59998 16.8687 8.8686 16.6 9.19998 16.6H13.2C13.5313 16.6 13.8 16.8687 13.8 17.2C13.8 17.5314 13.5313 17.8 13.2 17.8H9.19998C8.8686 17.8 8.59998 17.5314 8.59998 17.2Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39996 5.6C6.39996 4.16406 7.56402 3 8.99996 3H15C16.4359 3 17.6 4.16406 17.6 5.6V7.40002H18.4C19.8359 7.40002 21 8.56408 21 10V14C21 15.436 19.8359 16.6 18.4 16.6H17.6V19.4C17.6 20.2837 16.8836 21 16 21H7.99996C7.11631 21 6.39996 20.2837 6.39996 19.4V16.6H5.6C4.16406 16.6 3 15.436 3 14V10C3 8.56408 4.16406 7.40002 5.6 7.40002H6.39996V5.6ZM6.39996 15.4V13.8C6.39996 12.9164 7.11631 12.2 7.99996 12.2H16C16.8836 12.2 17.6 12.9164 17.6 13.8V15.4H18.4C19.1732 15.4 19.8 14.7732 19.8 14V10C19.8 9.22683 19.1732 8.60002 18.4 8.60002H5.6C4.8268 8.60002 4.2 9.22683 4.2 10V14C4.2 14.7732 4.8268 15.4 5.6 15.4H6.39996ZM16.4 5.6V7.40002H7.59996V5.6C7.59996 4.8268 8.22676 4.2 8.99996 4.2H15C15.7732 4.2 16.4 4.8268 16.4 5.6ZM7.59996 13.8C7.59996 13.5791 7.77905 13.4 7.99996 13.4H16C16.2209 13.4 16.4 13.5791 16.4 13.8V19.4C16.4 19.6209 16.2209 19.8 16 19.8H7.99996C7.77905 19.8 7.59996 19.6209 7.59996 19.4V13.8Z",
    fill: "#4C4C58"
  })));
};

PrintIcon.propTypes = iconPropTypes;
PrintIcon.defaultProps = iconDefaultProps;

var ShareIcon = function ShareIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 7.1C14.8 5.38792 16.1879 4 17.9 4C19.6121 4 21 5.38792 21 7.1C21 8.81208 19.6121 10.2 17.9 10.2C16.7831 10.2 15.8042 9.60937 15.2585 8.72342L9.14342 10.9074C9.18055 11.0992 9.2 11.2973 9.2 11.5C9.2 11.7214 9.1768 11.9373 9.13269 12.1456L15.2912 15.2248C15.8427 14.3677 16.805 13.8 17.9 13.8C19.6121 13.8 21 15.188 21 16.9C21 18.6121 19.6121 20 17.9 20C16.1879 20 14.8 18.6121 14.8 16.9C14.8 16.7108 14.8169 16.5255 14.8494 16.3456L8.65895 13.2503C8.10041 14.0653 7.16265 14.6 6.1 14.6C4.38792 14.6 3 13.2121 3 11.5C3 9.78794 4.38792 8.40002 6.1 8.40002C7.18231 8.40002 8.13508 8.95468 8.68957 9.79525L14.8399 7.5987C14.8136 7.43635 14.8 7.26977 14.8 7.1ZM17.9 5.2C16.8506 5.2 16 6.05066 16 7.1C16 8.14934 16.8506 9 17.9 9C18.9493 9 19.8 8.14934 19.8 7.1C19.8 6.05066 18.9493 5.2 17.9 5.2ZM6.1 9.60002C5.05066 9.60002 4.2 10.4507 4.2 11.5C4.2 12.5494 5.05066 13.4 6.1 13.4C7.14934 13.4 8 12.5494 8 11.5C8 10.4507 7.14934 9.60002 6.1 9.60002ZM16 16.9C16 15.8507 16.8506 15 17.9 15C18.9493 15 19.8 15.8507 19.8 16.9C19.8 17.9494 18.9493 18.8 17.9 18.8C16.8506 18.8 16 17.9494 16 16.9Z",
    fill: "#4C4C58"
  })));
};

ShareIcon.propTypes = iconPropTypes;
ShareIcon.defaultProps = iconDefaultProps;

var StarIcon = function StarIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: "1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3276 3.41402C10.1847 3.15695 9.81498 3.15691 9.67205 3.41395L7.87056 6.65372C7.63321 7.08058 7.20288 7.36515 6.71717 7.41646L3.70202 7.73494C3.38681 7.76823 3.25251 8.15332 3.47865 8.37541L5.98938 10.8412C6.38273 11.2275 6.53246 11.7984 6.37932 12.328L5.41043 15.6787C5.32107 15.9878 5.63678 16.2585 5.92858 16.123L9.36676 14.5269C9.76719 14.341 10.2292 14.3409 10.6297 14.5267L14.0725 16.124C14.3642 16.2594 14.6798 15.9888 14.5906 15.6798L13.6231 12.33C13.4703 11.8008 13.6198 11.2304 14.0125 10.8442L16.5223 8.37628C16.7483 8.15406 16.6138 7.7691 16.2986 7.73596L13.2835 7.41895C12.7974 7.36785 12.3667 7.08309 12.1293 6.65585L10.3276 3.41402ZM8.68883 2.86723C9.26055 1.83905 10.7394 1.83921 11.3109 2.86752L13.1126 6.10935C13.172 6.21616 13.2796 6.28734 13.4012 6.30012L16.4162 6.61712C17.677 6.74969 18.215 8.28956 17.3111 9.17844L14.8013 11.6464C14.7031 11.7429 14.6657 11.8855 14.7039 12.0178L15.6714 15.3677C16.0283 16.6036 14.7659 17.686 13.599 17.1446L10.1562 15.5473C10.0561 15.5008 9.94057 15.5008 9.84046 15.5473L6.40228 17.1434C5.23511 17.6853 3.97226 16.6024 4.32971 15.3662L5.29859 12.0155C5.33688 11.8831 5.29944 11.7404 5.20111 11.6438L2.69038 9.17806C1.78579 8.28968 2.32299 6.74934 3.58385 6.61616L6.599 6.29768C6.72042 6.28485 6.82801 6.21371 6.88735 6.107L8.68883 2.86723Z"
  }))));
};

StarIcon.propTypes = iconPropTypes;
StarIcon.defaultProps = iconDefaultProps;

var UnlockIcon = function UnlockIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 14.5C12.6 14.1686 12.3314 13.9 12 13.9C11.6687 13.9 11.4 14.1686 11.4 14.5V16.5C11.4 16.8314 11.6687 17.1 12 17.1C12.3314 17.1 12.6 16.8314 12.6 16.5V14.5Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.22499C10.9988 3.22499 10.0386 3.62272 9.3307 4.33067C8.62275 5.03862 8.22502 5.9988 8.22502 6.99999V9.60001H17C18.6569 9.60001 20 10.9432 20 12.6V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V12.6C4 10.9432 5.34315 9.60001 7 9.60001H7.02502V6.99999C7.02502 5.68054 7.54917 4.41513 8.48217 3.48214C9.41516 2.54914 10.6806 2.02499 12 2.02499C13.3195 2.02499 14.5849 2.54914 15.5179 3.48214C16.0355 3.99973 16.4272 4.61964 16.6735 5.29427C16.7871 5.60555 16.6269 5.95001 16.3156 6.06362C16.0043 6.17724 15.6598 6.017 15.5462 5.70572C15.3593 5.19374 15.0621 4.7234 14.6694 4.33067C13.9614 3.62272 13.0012 3.22499 12 3.22499ZM17 10.8H7C6.00589 10.8 5.2 11.6059 5.2 12.6V19C5.2 19.9941 6.00589 20.8 7 20.8H17C17.9941 20.8 18.8 19.9941 18.8 19V12.6C18.8 11.6059 17.9941 10.8 17 10.8Z",
    fill: "#4C4C58"
  })));
};

UnlockIcon.propTypes = iconPropTypes;
UnlockIcon.defaultProps = iconDefaultProps;

var WhatIsNewIcon = function WhatIsNewIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.74 5.5056C19.4669 5.31786 19.0934 5.38704 18.9056 5.6601C18.719 5.93155 18.7863 6.3023 19.0553 6.4911L19.0606 6.49503C19.0678 6.50048 19.0817 6.51128 19.1015 6.52775C19.1409 6.5607 19.2035 6.61627 19.2818 6.697C19.4382 6.85831 19.6579 7.12061 19.8814 7.50488C20.3261 8.26914 20.8 9.5394 20.8 11.5C20.8001 13.4606 20.3261 14.7309 19.8814 15.4952C19.6579 15.8794 19.4382 16.1417 19.2818 16.303C19.2035 16.3838 19.1409 16.4393 19.1015 16.4723C19.0817 16.4888 19.0678 16.4996 19.0606 16.505L19.0553 16.5089C18.7863 16.6977 18.719 17.0685 18.9056 17.3399C19.0934 17.613 19.4669 17.6822 19.74 17.4944L19.7414 17.4934L19.743 17.4923C19.7871 17.4615 19.8292 17.4279 19.8705 17.3935C19.9404 17.3351 20.0341 17.251 20.1433 17.1384C20.3619 16.913 20.6422 16.5737 20.9187 16.0986C21.474 15.1441 22.0001 13.6644 22 11.5C22 9.33564 21.474 7.8559 20.9187 6.90141C20.6422 6.42631 20.3619 6.08704 20.1433 5.86163C20.0341 5.74901 19.9404 5.66493 19.8705 5.60656C19.8283 5.57131 19.7853 5.53683 19.74 5.5056Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3482 5.71958C13.8746 5.36309 14.6 5.73283 14.6 6.3824V17.6176C14.6 18.2672 13.8746 18.6369 13.3482 18.2805C11.2096 16.8321 9.03454 15.7589 6.5607 15.6162C6.44729 16.5262 6.10716 17.3774 5.78668 18.0183C5.58759 18.4165 5.38874 18.748 5.23911 18.9807C5.16414 19.0973 5.10111 19.1898 5.05602 19.2543C5.03118 19.2897 5.00616 19.3251 4.98021 19.3598C4.78139 19.6249 4.40512 19.6788 4.14003 19.48C3.87509 19.2813 3.82127 18.9056 4.01966 18.6405C4.03781 18.616 4.05545 18.5911 4.07294 18.5661C4.10988 18.5133 4.16404 18.4339 4.22969 18.3318C4.36131 18.1271 4.53747 17.8335 4.71337 17.4817C4.94488 17.0187 5.1641 16.4781 5.29012 15.9202C5.31412 15.814 5.33474 15.7071 5.35142 15.6H4.6C3.16406 15.6 2 14.436 2 13V11C2 9.56407 3.16406 8.40002 4.6 8.40002L5.99997 8.40002C8.70846 8.39964 11.0497 7.27622 13.3482 5.71958ZM13.4 7.12245C11.3526 8.43269 9.14153 9.44404 6.60003 9.58356V14.4165C9.14153 14.556 11.3526 15.5674 13.4 16.8776V7.12245ZM4.6 9.60002C3.8268 9.60002 3.2 10.2268 3.2 11L3.2 13C3.2 13.7732 3.8268 14.4 4.6 14.4H5.39999V9.60002H4.6Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4912 8.68202C16.6669 8.40102 17.037 8.31559 17.318 8.49122C17.3479 8.51089 17.3772 8.53097 17.4057 8.55259C17.4485 8.58507 17.5036 8.63015 17.5666 8.68925C17.6928 8.80753 17.8509 8.98202 18.0054 9.22346C18.3179 9.71174 18.6 10.4492 18.6 11.5C18.6 12.5509 18.3179 13.2883 18.0054 13.7766C17.8509 14.018 17.6928 14.1925 17.5666 14.3108C17.5036 14.3699 17.4485 14.415 17.4057 14.4474L17.318 14.5088C17.037 14.6844 16.6669 14.599 16.4912 14.318C16.3176 14.0402 16.3991 13.6752 16.6725 13.4973L16.6803 13.4916C16.6922 13.4825 16.7152 13.4641 16.7459 13.4353C16.8073 13.3778 16.8992 13.2789 16.9947 13.1297C17.1822 12.8367 17.4 12.3242 17.4 11.5C17.4 10.6759 17.1822 10.1633 16.9947 9.87033C16.8992 9.72114 16.8072 9.6222 16.7459 9.56469C16.7152 9.5359 16.6922 9.51751 16.6803 9.50848L16.6725 9.50276C16.3991 9.32479 16.3176 8.95983 16.4912 8.68202Z",
    fill: "#4C4C58"
  })));
};

WhatIsNewIcon.propTypes = iconPropTypes;
WhatIsNewIcon.defaultProps = iconDefaultProps;

var ProfileIcon = function ProfileIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18.4529 17.9833C19.9095 16.4132 20.8 14.3106 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 14.3106 4.09052 16.4132 5.54708 17.9833C6.58025 16.327 8.23402 15.0966 10.1837 14.6184C8.60311 13.9203 7.5 12.339 7.5 10.5C7.5 8.01472 9.51472 6 12 6C14.4853 6 16.5 8.01472 16.5 10.5C16.5 12.339 15.3969 13.9203 13.8163 14.6184C15.766 15.0965 17.4198 16.3269 18.4529 17.9833ZM17.5574 18.8235C16.4536 16.8966 14.3777 15.6 12 15.6C9.6223 15.6 7.54639 16.8966 6.44257 18.8235C7.95782 20.0591 9.89238 20.8 12 20.8C14.1076 20.8 16.0422 20.0591 17.5574 18.8235ZM12 13.8C13.8225 13.8 15.3 12.3225 15.3 10.5C15.3 8.67746 13.8225 7.2 12 7.2C10.1775 7.2 8.7 8.67746 8.7 10.5C8.7 12.3225 10.1775 13.8 12 13.8Z",
    fill: "#4C4C58"
  })));
};

ProfileIcon.propTypes = iconPropTypes;
ProfileIcon.defaultProps = iconDefaultProps;

var AdminIcon = function AdminIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 12C13.4 11.6687 13.6686 11.4 14 11.4H17.5C17.8314 11.4 18.1 11.6687 18.1 12C18.1 12.3314 17.8314 12.6 17.5 12.6H14C13.6686 12.6 13.4 12.3314 13.4 12Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.9C13.6686 13.9 13.4 14.1687 13.4 14.5C13.4 14.8314 13.6686 15.1 14 15.1H18.5C18.8314 15.1 19.1 14.8314 19.1 14.5C19.1 14.1687 18.8314 13.9 18.5 13.9H14Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.90002C11.52 2.90002 11.1201 3.02175 10.8 3.23517C10.4836 3.44609 10.2802 3.72302 10.1508 3.9817C10.0227 4.23802 9.96158 4.48709 9.9316 4.66701C9.90734 4.81255 9.902 4.90909 9.90002 5H5C3.34315 5 2 6.34315 2 8V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V8C22 6.34315 20.6569 5 19 5L14.1 4.99739C14.0994 4.90538 14.0929 4.8142 14.0684 4.66701C14.0384 4.48709 13.9773 4.23802 13.8492 3.9817C13.7198 3.72302 13.5164 3.44609 13.2 3.23517C12.8799 3.02175 12.48 2.90002 12 2.90002ZM14.1 6.2V7.50002C14.1 7.8314 13.8314 8.10002 13.5 8.10002H10.5C10.1686 8.10002 9.89999 7.8314 9.89999 7.50002V6.2H5C4.00589 6.2 3.2 7.00589 3.2 8V17C3.2 17.6449 3.53916 18.2106 4.04883 18.5285C4.66293 17.1696 5.74106 16.0951 7.07089 15.6384C6.13524 15.1305 5.49999 14.1395 5.49999 13C5.49999 11.3432 6.84314 10 8.49999 10C10.1568 10 11.5 11.3432 11.5 13C11.5 14.1395 10.8648 15.1305 9.9291 15.6384C11.339 16.1226 12.466 17.3012 13.057 18.777L12.9994 18.8H19C19.9941 18.8 20.8 17.9941 20.8 17V8C20.8 7.00589 19.9941 6.2 19 6.2H14.1ZM11.1 6.90002V5.00422L11.1 5.00317C11.1016 4.95674 11.1076 4.91001 11.1153 4.86429C11.1322 4.76296 11.1648 4.63702 11.2242 4.51835C11.2823 4.40203 11.3601 4.30396 11.4656 4.23363C11.5674 4.1658 11.73 4.10002 12 4.10002C12.27 4.10002 12.4326 4.1658 12.5344 4.23363C12.6399 4.30396 12.7177 4.40203 12.7758 4.51835C12.8352 4.63702 12.8678 4.76296 12.8847 4.86429C12.897 4.93795 12.8996 4.99137 12.9 5.00317L12.9 5.00422V6.90002H11.1ZM5.24922 18.8C5.94257 17.4447 7.16714 16.6 8.49999 16.6C9.83285 16.6 11.0574 17.4447 11.7508 18.8H5.24922ZM10.3 13C10.3 13.9941 9.49411 14.8 8.49999 14.8C7.50588 14.8 6.69999 13.9941 6.69999 13C6.69999 12.0059 7.50588 11.2 8.49999 11.2C9.49411 11.2 10.3 12.0059 10.3 13Z",
    fill: "#4C4C58"
  })));
};

AdminIcon.propTypes = iconPropTypes;
AdminIcon.defaultProps = iconDefaultProps;

var HelpIcon = function HelpIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 16.8601 7.13989 20.8 12 20.8ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13989 16.8601 3.2 12 3.2C7.13989 3.2 3.2 7.13989 3.2 12C3.2 16.8601 7.13989 20.8 12 20.8ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8515 9.0738C13.6345 8.13228 12.7455 7.50353 11.7855 7.61262C10.8255 7.72171 10.1002 8.53391 10.1 9.50011C10.0999 9.83148 9.83126 10.1001 9.49989 10.1C9.16851 10.0999 8.89994 9.83125 8.9 9.49988C8.9003 7.92345 10.0836 6.59829 11.65 6.42029C13.2163 6.2423 14.6668 7.26816 15.0208 8.80432C15.3748 10.3405 14.5196 11.8977 13.0333 12.4232C12.7735 12.515 12.5999 12.7608 12.6 13.0363V13.875C12.6 14.2064 12.3314 14.475 12 14.475C11.6686 14.475 11.4 14.2064 11.4 13.875V13.037C11.3997 12.2527 11.8939 11.5532 12.6333 11.2918C13.5443 10.9697 14.0684 10.0153 13.8515 9.0738Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0875 16.6875C11.0875 16.1835 11.496 15.775 12 15.775C12.504 15.775 12.9125 16.1835 12.9125 16.6875C12.9125 17.1915 12.504 17.6 12 17.6C11.496 17.6 11.0875 17.1915 11.0875 16.6875Z",
    fill: "#4C4C58"
  })));
};

HelpIcon.propTypes = iconPropTypes;
HelpIcon.defaultProps = iconDefaultProps;

var TimerIcon = function TimerIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42426 10.0758C9.18995 9.84145 8.81005 9.84145 8.57574 10.0758C8.34142 10.3101 8.34142 10.69 8.57574 10.9243L11.5757 13.9243C11.8101 14.1586 12.1899 14.1586 12.4243 13.9243C12.6586 13.69 12.6586 13.3101 12.4243 13.0758L9.42426 10.0758Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4 2.6C9.4 2.26863 9.66863 2 10 2H14C14.3314 2 14.6 2.26863 14.6 2.6C14.6 2.93137 14.3314 3.2 14 3.2H12.6V5.02087C14.4959 5.15309 16.2205 5.90706 17.5712 7.08025L18.1515 6.50004L17.9757 6.3243C17.7414 6.08998 17.7414 5.71008 17.9757 5.47578C18.2101 5.24147 18.59 5.24147 18.8243 5.47579L20.0243 6.67584C20.2586 6.91016 20.2586 7.29006 20.0242 7.52437C19.7899 7.75868 19.41 7.75867 19.1757 7.52435L19 7.34859L18.4198 7.92878C19.7156 9.4207 20.5 11.3688 20.5 13.5C20.5 18.1944 16.6944 22 12 22C7.30558 22 3.5 18.1944 3.5 13.5C3.5 9.00732 6.98556 5.32872 11.4 5.02087V3.2H10C9.66863 3.2 9.4 2.93137 9.4 2.6ZM19.3 13.5C19.3 17.5317 16.0317 20.8 12 20.8C7.96832 20.8 4.7 17.5317 4.7 13.5C4.7 9.46835 7.96832 6.20002 12 6.20002C16.0317 6.20002 19.3 9.46835 19.3 13.5Z",
    fill: "#4C4C58"
  })));
};

TimerIcon.propTypes = iconPropTypes;
TimerIcon.defaultProps = iconDefaultProps;

var KeyboardIcon = function KeyboardIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.60001 14.9C8.26864 14.9 8.00001 15.1686 8.00001 15.5C8.00001 15.8314 8.26864 16.1 8.60001 16.1H15.4C15.7314 16.1 16 15.8314 16 15.5C16 15.1686 15.7314 14.9 15.4 14.9H8.60001Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90001 9.4C9.90001 9.89706 9.49706 10.3 9.00001 10.3C8.50295 10.3 8.10001 9.89706 8.10001 9.4C8.10001 8.90294 8.50295 8.5 9.00001 8.5C9.49706 8.5 9.90001 8.90294 9.90001 9.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.3C12.4971 10.3 12.9 9.89706 12.9 9.4C12.9 8.90294 12.4971 8.5 12 8.5C11.5029 8.5 11.1 8.90294 11.1 9.4C11.1 9.89706 11.5029 10.3 12 10.3Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9.4C15.9 9.89706 15.4971 10.3 15 10.3C14.5029 10.3 14.1 9.89706 14.1 9.4C14.1 8.90294 14.5029 8.5 15 8.5C15.4971 8.5 15.9 8.90294 15.9 9.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.3C18.4971 10.3 18.9 9.89706 18.9 9.4C18.9 8.90294 18.4971 8.5 18 8.5C17.5029 8.5 17.1 8.90294 17.1 9.4C17.1 9.89706 17.5029 10.3 18 10.3Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90001 9.4C6.90001 9.89706 6.49706 10.3 6.00001 10.3C5.50295 10.3 5.10001 9.89706 5.10001 9.4C5.10001 8.90294 5.50295 8.5 6.00001 8.5C6.49706 8.5 6.90001 8.90294 6.90001 9.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3C12.4971 13.3 12.9 12.8971 12.9 12.4C12.9 11.9029 12.4971 11.5 12 11.5C11.5029 11.5 11.1 11.9029 11.1 12.4C11.1 12.8971 11.5029 13.3 12 13.3Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90001 12.4C9.90001 12.8971 9.49706 13.3 9.00001 13.3C8.50295 13.3 8.10001 12.8971 8.10001 12.4C8.10001 11.9029 8.50295 11.5 9.00001 11.5C9.49706 11.5 9.90001 11.9029 9.90001 12.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.3C15.4971 13.3 15.9 12.8971 15.9 12.4C15.9 11.9029 15.4971 11.5 15 11.5C14.5029 11.5 14.1 11.9029 14.1 12.4C14.1 12.8971 14.5029 13.3 15 13.3Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 12.4C18.9 12.8971 18.4971 13.3 18 13.3C17.5029 13.3 17.1 12.8971 17.1 12.4C17.1 11.9029 17.5029 11.5 18 11.5C18.4971 11.5 18.9 11.9029 18.9 12.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 13.3C6.49706 13.3 6.90001 12.8971 6.90001 12.4C6.90001 11.9029 6.49706 11.5 6.00001 11.5C5.50295 11.5 5.10001 11.9029 5.10001 12.4C5.10001 12.8971 5.50295 13.3 6.00001 13.3Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.5C2 6.84315 3.34315 5.5 5 5.5H19C20.6569 5.5 22 6.84315 22 8.5V15.5C22 17.1569 20.6569 18.5 19 18.5H5C3.34315 18.5 2 17.1569 2 15.5V8.5ZM5 6.7H19C19.9941 6.7 20.8 7.50589 20.8 8.5V15.5C20.8 16.4941 19.9941 17.3 19 17.3H5C4.00589 17.3 3.2 16.4941 3.2 15.5V8.5C3.2 7.50589 4.00589 6.7 5 6.7Z",
    fill: "#4C4C58"
  })));
};

KeyboardIcon.propTypes = iconPropTypes;
KeyboardIcon.defaultProps = iconDefaultProps;

var LogOffIcon = function LogOffIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.60436C3 5.66696 3.65106 4.85533 4.56614 4.65198L9.56614 3.54087C10.8152 3.26331 12 4.21375 12 5.49324V18.7655C12 19.9575 10.9639 20.8849 9.77914 20.7532L4.77914 20.1977C3.76627 20.0852 3 19.229 3 18.2099V6.60436ZM4.82646 5.82341L9.82646 4.71229C10.3261 4.60127 10.8 4.98145 10.8 5.49324V18.7655C10.8 19.2423 10.3855 19.6132 9.91165 19.5606L4.91165 19.005C4.50651 18.96 4.2 18.6176 4.2 18.2099V6.60436C4.2 6.2294 4.46043 5.90475 4.82646 5.82341Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 12.5C13.4 12.1686 13.6686 11.9 14 11.9H18.9923L17.5672 10.4155C17.3377 10.1765 17.3454 9.79666 17.5845 9.56718C17.8235 9.33769 18.2033 9.34545 18.4328 9.58449L20.8328 12.0845C21.0557 12.3167 21.0557 12.6834 20.8328 12.9155L18.4328 15.4155C18.2033 15.6546 17.8235 15.6623 17.5845 15.4328C17.3454 15.2034 17.3377 14.8235 17.5672 14.5845L18.9923 13.1H14C13.6686 13.1 13.4 12.8314 13.4 12.5Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.90001C13.6686 4.90001 13.4 5.16864 13.4 5.50001C13.4 5.83138 13.6686 6.10001 14 6.10001H16C16.2209 6.10001 16.4 6.2791 16.4 6.50001V7.50001C16.4 7.83138 16.6686 8.10001 17 8.10001C17.3314 8.10001 17.6 7.83138 17.6 7.50001V6.50001C17.6 5.61636 16.8837 4.90001 16 4.90001H14Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9C17.3314 16.9 17.6 17.1686 17.6 17.5V18.5C17.6 19.3837 16.8837 20.1 16 20.1H14C13.6686 20.1 13.4 19.8314 13.4 19.5C13.4 19.1686 13.6686 18.9 14 18.9H16C16.2209 18.9 16.4 18.7209 16.4 18.5V17.5C16.4 17.1686 16.6686 16.9 17 16.9Z",
    fill: "#4C4C58"
  })));
};

LogOffIcon.propTypes = iconPropTypes;
LogOffIcon.defaultProps = iconDefaultProps;

var TaskIcon = function TaskIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V11.4941C21 10.6985 20.6839 9.93543 20.1213 9.37282L14.6272 3.87868C14.0646 3.31607 13.3015 3 12.5059 3H6ZM4.2 6C4.2 5.00589 5.00589 4.2 6 4.2H12.4V9.00002C12.4 10.436 13.5641 11.6 15 11.6H19.8V18C19.8 18.9941 18.9941 19.8 18 19.8H6C5.00589 19.8 4.2 18.9941 4.2 18V6ZM19.4293 10.4C19.3814 10.3374 19.3292 10.2777 19.2728 10.2213L13.7787 4.72721C13.7223 4.67085 13.6626 4.6186 13.6 4.57068V9.00002C13.6 9.77322 14.2268 10.4 15 10.4H19.4293Z",
    fill: "#4C4C58"
  })));
};

TaskIcon.propTypes = iconPropTypes;
TaskIcon.defaultProps = iconDefaultProps;

var SubTaskIcon = function SubTaskIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.33398C3.5 3.05784 3.27614 2.83398 3 2.83398C2.72386 2.83398 2.5 3.05784 2.5 3.33398V12.2923C2.5 13.9492 3.84315 15.2923 5.5 15.2923H12.1294C12.364 16.5492 13.4667 17.5006 14.7917 17.5006C16.2874 17.5006 17.5 16.2881 17.5 14.7923C17.5 13.2965 16.2874 12.084 14.7917 12.084C13.4667 12.084 12.364 13.0354 12.1294 14.2923H5.5C4.39543 14.2923 3.5 13.3969 3.5 12.2923V7.37565H7.54606C7.78066 8.63255 8.88339 9.58396 10.2083 9.58396C11.7041 9.58396 12.9167 8.3714 12.9167 6.87563C12.9167 5.37986 11.7041 4.1673 10.2083 4.1673C8.88338 4.1673 7.78064 5.11873 7.54606 6.37565H3.5V3.33398ZM16.5 14.7923C16.5 15.7358 15.7352 16.5006 14.7917 16.5006C13.8482 16.5006 13.0833 15.7358 13.0833 14.7923C13.0833 13.8488 13.8482 13.084 14.7917 13.084C15.7352 13.084 16.5 13.8488 16.5 14.7923ZM10.2083 8.58396C11.1518 8.58396 11.9167 7.81912 11.9167 6.87563C11.9167 5.93214 11.1518 5.1673 10.2083 5.1673C9.26485 5.1673 8.5 5.93214 8.5 6.87563C8.5 7.81912 9.26485 8.58396 10.2083 8.58396Z",
    fill: "#4C4C58"
  })));
};

SubTaskIcon.propTypes = iconPropTypes;
SubTaskIcon.defaultProps = iconDefaultProps;

var ProjectIcon = function ProjectIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60001 10.7C6.26864 10.7 6.00001 10.9686 6.00001 11.3C6.00001 11.6314 6.26864 11.9 6.60001 11.9H10.6C10.9314 11.9 11.2 11.6314 11.2 11.3C11.2 10.9686 10.9314 10.7 10.6 10.7H6.60001Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 13.5C9.4 13.1686 9.66863 12.9 10 12.9H14C14.3314 12.9 14.6 13.1686 14.6 13.5C14.6 13.8314 14.3314 14.1 14 14.1H10C9.66863 14.1 9.4 13.8314 9.4 13.5Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 15.1C13.0686 15.1 12.8 15.3686 12.8 15.7C12.8 16.0314 13.0686 16.3 13.4 16.3H17.4C17.7314 16.3 18 16.0314 18 15.7C18 15.3686 17.7314 15.1 17.4 15.1H13.4Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7ZM19 5.2H5C4.00589 5.2 3.2 6.00589 3.2 7V7.4H20.8V7C20.8 6.00589 19.9941 5.2 19 5.2ZM3.2 17V8.6H20.8V17C20.8 17.9941 19.9941 18.8 19 18.8H5C4.00589 18.8 3.2 17.9941 3.2 17Z",
    fill: "#4C4C58"
  })));
};

ProjectIcon.propTypes = iconPropTypes;
ProjectIcon.defaultProps = iconDefaultProps;

var ConnectedProjectIcon = function ConnectedProjectIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C3.34315 4 2 5.34315 2 7V14.5C2 16.1569 3.34315 17.5 5 17.5H16.5C18.1569 17.5 19.5 16.1569 19.5 14.5V7C19.5 5.34315 18.1569 4 16.5 4H5ZM16.5 5.2H5C4.00589 5.2 3.2 6.00589 3.2 7V7.4H18.3V7C18.3 6.00589 17.4941 5.2 16.5 5.2ZM18.3 8.6H3.2V14.5C3.2 15.4941 4.00589 16.3 5 16.3H16.5C17.4941 16.3 18.3 15.4941 18.3 14.5V8.6Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 8.30002C21.7314 8.30002 22 8.56865 22 8.90002V17C22 18.6569 20.6568 20 19 20H6.89999C6.56862 20 6.29999 19.7314 6.29999 19.4C6.29999 19.0687 6.56862 18.8 6.89999 18.8H19C19.9941 18.8 20.8 17.9941 20.8 17V8.90002C20.8 8.56865 21.0686 8.30002 21.4 8.30002Z",
    fill: "#4C4C58"
  })));
};

ConnectedProjectIcon.propTypes = iconPropTypes;
ConnectedProjectIcon.defaultProps = iconDefaultProps;

var TimeEntryIcon = function TimeEntryIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32222 3.6C8.32222 3.26863 8.05359 3 7.72222 3C7.39085 3 7.12222 3.26863 7.12222 3.6V4.45001H6C4.34315 4.45001 3 5.79316 3 7.45001V18C3 19.6569 4.34315 21 6 21H10C10.3314 21 10.6 20.7314 10.6 20.4C10.6 20.0686 10.3314 19.8 10 19.8H6C5.00589 19.8 4.2 18.9941 4.2 18V9.28966H19.8V9.72501C19.8 10.0564 20.0686 10.325 20.4 10.325C20.7314 10.325 21 10.0564 21 9.72501V7.45001C21 5.79316 19.6569 4.45001 18 4.45001H15.8778V3.6C15.8778 3.26863 15.6091 3 15.2778 3C14.9464 3 14.6778 3.26863 14.6778 3.6V4.45001H8.32222V3.6ZM19.8 8.08966V7.45001C19.8 6.4559 18.9941 5.65001 18 5.65001H15.8778V6.42759C15.8778 6.75896 15.6091 7.02759 15.2778 7.02759C14.9464 7.02759 14.6778 6.75896 14.6778 6.42759V5.65001H8.32222V6.42759C8.32222 6.75896 8.05359 7.02759 7.72222 7.02759C7.39085 7.02759 7.12222 6.75896 7.12222 6.42759V5.65001H6C5.00589 5.65001 4.2 6.4559 4.2 7.45001V8.08966H19.8Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5954C16.3314 13.5954 16.6 13.864 16.6 14.1954V15.7515L18.2243 17.3758C18.4586 17.6101 18.4586 17.99 18.2243 18.2243C17.9899 18.4586 17.61 18.4586 17.3757 18.2243L15.5757 16.4243C15.5182 16.3668 15.4748 16.3005 15.4455 16.2297C15.4162 16.159 15.4 16.0814 15.4 16V14.1954C15.4 13.864 15.6686 13.5954 16 13.5954Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.5C19.0376 21.5 21.5 19.0376 21.5 16C21.5 12.9625 19.0376 10.5 16 10.5C12.9624 10.5 10.5 12.9625 10.5 16C10.5 19.0376 12.9624 21.5 16 21.5ZM16 20.3C18.3748 20.3 20.3 18.3748 20.3 16C20.3 13.6252 18.3748 11.7 16 11.7C13.6252 11.7 11.7 13.6252 11.7 16C11.7 18.3748 13.6252 20.3 16 20.3Z",
    fill: "#4C4C58"
  })));
};

TimeEntryIcon.propTypes = iconPropTypes;
TimeEntryIcon.defaultProps = iconDefaultProps;

var TeamMemberIcon = function TeamMemberIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.96252C10.426 3.96252 9.15002 5.23851 9.15002 6.81252C9.15002 8.20748 10.1522 9.36836 11.4759 9.61443C9.49518 9.82001 8 11.1837 8 13V14.6875C8 15.0189 8.26863 15.2875 8.6 15.2875H9.46029L9.90334 19.4633C9.93572 19.7685 10.1931 20 10.5 20H13.5C13.8069 20 14.0643 19.7685 14.0966 19.4633L14.5397 15.2875H15.4C15.7314 15.2875 16 15.0189 16 14.6875V13C16 11.1837 14.5048 9.82003 12.5242 9.61443C13.8478 9.36837 14.85 8.20748 14.85 6.81252C14.85 5.23851 13.574 3.96252 12 3.96252ZM10.35 6.81252C10.35 5.90125 11.0888 5.16252 12 5.16252C12.9113 5.16252 13.65 5.90125 13.65 6.81252C13.65 7.72379 12.9113 8.46252 12 8.46252C11.0888 8.46252 10.35 7.72379 10.35 6.81252ZM9.2 13C9.2 11.8669 10.235 10.7875 12 10.7875C13.765 10.7875 14.8 11.8669 14.8 13V14.0875H14C13.6931 14.0875 13.4357 14.3191 13.4033 14.6242L12.9603 18.8H11.0397L10.5966 14.6242C10.5643 14.3191 10.3069 14.0875 9.99999 14.0875H9.2V13Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 8.50002C3.125 7.23667 4.14915 6.21252 5.4125 6.21252C6.67585 6.21252 7.7 7.23667 7.7 8.50002C7.7 9.60875 6.91121 10.5332 5.86419 10.7429C6.07972 10.7716 6.29393 10.821 6.50387 10.8916C6.81793 10.9973 6.98685 11.3376 6.88116 11.6516C6.77548 11.9657 6.4352 12.1346 6.12113 12.0289C5.44573 11.8017 4.70222 11.9132 4.12329 12.3288C3.55471 12.7369 3.21311 13.3892 3.20037 14.0875H3.725C4.0183 14.0875 4.26862 14.2996 4.31684 14.5889L4.79578 17.4625H6.02922L6.22766 16.2719C6.28214 15.945 6.59128 15.7242 6.91814 15.7787C7.245 15.8332 7.46581 16.1423 7.41134 16.4692L7.12934 18.1612C7.08112 18.4505 6.8308 18.6625 6.5375 18.6625H4.2875C3.9942 18.6625 3.74388 18.4505 3.69566 18.1612L3.21672 15.2875H2.6C2.26863 15.2875 2 15.0189 2 14.6875V14.125C2.00117 13.0263 2.53096 11.9946 3.42356 11.3539C3.88527 11.0225 4.41489 10.8165 4.96275 10.7433C3.91476 10.5344 3.125 9.60943 3.125 8.50002ZM5.4125 7.41252C4.81189 7.41252 4.325 7.89941 4.325 8.50002C4.325 9.10063 4.81189 9.58752 5.4125 9.58752C6.01311 9.58752 6.5 9.10063 6.5 8.50002C6.5 7.89941 6.01311 7.41252 5.4125 7.41252Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3 8.50002C16.3 7.23667 17.3241 6.21252 18.5875 6.21252C19.8508 6.21252 20.875 7.23667 20.875 8.50002C20.875 9.60944 20.0852 10.5344 19.0372 10.7433C19.5851 10.8165 20.1147 11.0225 20.5765 11.3539C21.469 11.9946 21.9988 13.0257 22 14.1244V14.6875C22 15.0189 21.7314 15.2875 21.4 15.2875H20.7833L20.3043 18.1612C20.2561 18.4505 20.0058 18.6625 19.7125 18.6625H17.4625C17.1692 18.6625 16.9189 18.4505 16.8707 18.1612L16.5887 16.4692C16.5342 16.1423 16.755 15.8332 17.0819 15.7787C17.4087 15.7242 17.7179 15.945 17.7723 16.2719L17.9708 17.4625H19.2042L19.6832 14.5889C19.7314 14.2996 19.9817 14.0875 20.275 14.0875H20.7996C20.7869 13.3892 20.4453 12.7369 19.8767 12.3288C19.2978 11.9132 18.5543 11.8017 17.8789 12.0289C17.5648 12.1346 17.2245 11.9657 17.1188 11.6516C17.0132 11.3376 17.1821 10.9973 17.4961 10.8916C17.7061 10.821 17.9203 10.7716 18.1358 10.7429C17.0888 10.5333 16.3 9.60876 16.3 8.50002ZM18.5875 7.41252C17.9869 7.41252 17.5 7.89941 17.5 8.50002C17.5 9.10063 17.9869 9.58752 18.5875 9.58752C19.1881 9.58752 19.675 9.10063 19.675 8.50002C19.675 7.89941 19.1881 7.41252 18.5875 7.41252Z",
    fill: "#4C4C58"
  })));
};

TeamMemberIcon.propTypes = iconPropTypes;
TeamMemberIcon.defaultProps = iconDefaultProps;

var ClientIcon = function ClientIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50002 3C5.92601 3 4.65002 4.27599 4.65002 5.85C4.65002 7.42401 5.92601 8.7 7.50002 8.7C9.07404 8.7 10.35 7.42401 10.35 5.85C10.35 4.27599 9.07404 3 7.50002 3ZM5.85002 5.85C5.85002 4.93873 6.58875 4.2 7.50002 4.2C8.41129 4.2 9.15002 4.93873 9.15002 5.85C9.15002 6.76127 8.41129 7.5 7.50002 7.5C6.58875 7.5 5.85002 6.76127 5.85002 5.85Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.0001C12.1164 13.0001 11.4 13.7164 11.4 14.6001V19.4C11.4 20.2837 12.1164 21 13 21H19.4C20.2837 21 21 20.2837 21 19.4V14.6001C21 13.7164 20.2837 13.0001 19.4 13.0001H18.5V12.4C18.5 11.5164 17.7837 10.8 16.9 10.8H15.7C14.8164 10.8 14.1 11.5164 14.1 12.4V13.0001H13ZM17.3 12.4V13.0001H15.3V12.4C15.3 12.1791 15.4791 12 15.7 12H16.9C17.121 12 17.3 12.1791 17.3 12.4ZM12.6 14.6001C12.6 14.3791 12.7791 14.2001 13 14.2001H19.4C19.6209 14.2001 19.8 14.3791 19.8 14.6001V15.2H12.6V14.6001ZM15.7 16.4V17C15.7 17.3314 15.9686 17.6 16.3 17.6C16.6314 17.6 16.9 17.3314 16.9 17V16.4H19.8V19.4C19.8 19.621 19.6209 19.8 19.4 19.8H13C12.7791 19.8 12.6 19.621 12.6 19.4V16.4H15.7Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96252 13.1251C2.96252 10.5965 5.01703 8.7 7.50002 8.7C9.31176 8.7 10.8955 9.70642 11.621 11.244C11.7624 11.5437 11.6341 11.9013 11.3344 12.0427C11.0347 12.1841 10.6771 12.0557 10.5357 11.7561C10.015 10.6523 8.86289 9.90007 7.50002 9.90007C5.63377 9.90007 4.16252 11.3044 4.16252 13.1251V14.2126H5.25002C5.55812 14.2126 5.81615 14.4459 5.84701 14.7525L6.35515 19.8001H8.64489L9.15304 14.7525C9.18623 14.4228 9.48042 14.1824 9.81012 14.2156C10.1398 14.2488 10.3802 14.543 10.347 14.8727L9.78451 20.4602C9.75365 20.7667 9.49562 21.0001 9.18752 21.0001H5.81252C5.50443 21.0001 5.2464 20.7667 5.21554 20.4602L4.70739 15.4126H3.56252C3.23115 15.4126 2.96252 15.1439 2.96252 14.8126V13.1251Z",
    fill: "#4C4C58"
  })));
};

ClientIcon.propTypes = iconPropTypes;
ClientIcon.defaultProps = iconDefaultProps;

var ReportIcon = function ReportIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3841 10.0391C19.6387 10.2512 19.6731 10.6295 19.461 10.8841L16.961 13.8841C16.7716 14.1113 16.4449 14.1667 16.1913 14.0145L14.132 12.7789L11.961 15.3841C11.7518 15.6351 11.3803 15.6726 11.1252 15.4685L9.08445 13.8359L6.96096 16.3841C6.84696 16.5209 6.67809 16.6 6.50002 16.6H5.00002C4.66865 16.6 4.40002 16.3314 4.40002 16C4.40002 15.6686 4.66865 15.4 5.00002 15.4H6.219L8.53909 12.6159C8.74824 12.3649 9.11974 12.3274 9.37484 12.5315L11.4156 14.1641L13.5391 11.6159C13.7284 11.3887 14.0551 11.3333 14.3087 11.4855L16.3681 12.7211L18.5391 10.1159C18.7512 9.86132 19.1296 9.82693 19.3841 10.0391Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00002 8.00547V17C2.00002 18.6569 3.34317 20 5.00002 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5.00002C3.34317 4 2.00002 5.34315 2.00002 7V7.99453L2 8L2.00002 8.00547ZM19 5.2H5.00002C4.00591 5.2 3.20002 6.00589 3.20002 7V7.4H20.8V7C20.8 6.00589 19.9941 5.2 19 5.2ZM20.8 8.6H3.20002V17C3.20002 17.9941 4.00591 18.8 5.00002 18.8H19C19.9941 18.8 20.8 17.9941 20.8 17V8.6Z",
    fill: "#4C4C58"
  })));
};

ReportIcon.propTypes = iconPropTypes;
ReportIcon.defaultProps = iconDefaultProps;

var ExpenseIcon = function ExpenseIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79999 6.39993C7.79999 6.06856 8.06861 5.79993 8.39999 5.79993H10.2C10.5314 5.79993 10.8 6.06856 10.8 6.39993C10.8 6.7313 10.5314 6.99993 10.2 6.99993H8.39999C8.06861 6.99993 7.79999 6.7313 7.79999 6.39993Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 9.19991C8.40002 8.86854 8.66865 8.59991 9.00002 8.59991H13.8C14.1314 8.59991 14.4 8.86854 14.4 9.19991C14.4 9.53129 14.1314 9.79991 13.8 9.79991H9.00002C8.66865 9.79991 8.40002 9.53129 8.40002 9.19991Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 11.3999C8.66865 11.3999 8.40002 11.6685 8.40002 11.9999C8.40002 12.3313 8.66865 12.5999 9.00002 12.5999H13.8C14.1314 12.5999 14.4 12.3313 14.4 11.9999C14.4 11.6685 14.1314 11.3999 13.8 11.3999H9.00002Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 14.8C8.40002 14.4686 8.66865 14.2 9.00002 14.2H13.8C14.1314 14.2 14.4 14.4686 14.4 14.8C14.4 15.1313 14.1314 15.4 13.8 15.4H9.00002C8.66865 15.4 8.40002 15.1313 8.40002 14.8Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 16.9999C8.66865 16.9999 8.40002 17.2686 8.40002 17.5999C8.40002 17.9313 8.66865 18.1999 9.00002 18.1999H11.4C11.7314 18.1999 12 17.9313 12 17.5999C12 17.2686 11.7314 16.9999 11.4 16.9999H9.00002Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 2.99994C6.7828 2.99994 5.4 4.23313 5.4 5.83994V17.0399C5.4 18.0442 5.13505 18.6147 4.80332 18.9846C4.45387 19.3743 3.9694 19.6129 3.38283 19.8406C3.11364 19.9451 2.95709 20.2266 3.01026 20.5104C3.06342 20.7942 3.31123 20.9999 3.6 20.9999H13.2C15.4799 20.9999 17.4 19.2653 17.4 17.0399V9.23996H20.4C20.7314 9.23996 21 8.97133 21 8.63996V5.39994C21 4.0751 19.9265 3.00098 18.6019 2.99994L18.6 2.99994H8.4ZM16.5211 4.19994H8.4C7.36622 4.19994 6.6 4.97251 6.6 5.83994V17.0399C6.6 18.2756 6.26495 19.1522 5.69667 19.7858L5.68394 19.7999H13.2C14.8965 19.7999 16.2 18.5259 16.2 17.0399V8.63994L16.2 8.63604V5.39994C16.2 4.9628 16.3169 4.55295 16.5211 4.19994ZM18.6 4.19994C17.9373 4.19995 17.4 4.7372 17.4 5.39994V8.03996H19.8V5.39994C19.8 4.7372 19.2627 4.19994 18.6 4.19994Z",
    fill: "#4C4C58"
  })));
};

ExpenseIcon.propTypes = iconPropTypes;
ExpenseIcon.defaultProps = iconDefaultProps;
var _excluded = ["variant"];
var WARNING_TYPE = {
  DANGER: 'danger',
  // Exclamation point
  NO_WARNING: 'no_warning' // Check mark

};
var VARIANT = {
  DANGER: {
    warningType: WARNING_TYPE.DANGER,
    color: '#F84746'
  },
  WARNING: {
    warningType: WARNING_TYPE.DANGER,
    color: '#FFC92D'
  },
  NO_WARNING: {
    warningType: WARNING_TYPE.NO_WARNING,
    color: '#00DA80'
  }
};

var WarningIcon = function WarningIcon(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  var warningType = variant.warningType,
      color = variant.color;
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({}, props, {
    overrideColor: false
  }), warningType === WARNING_TYPE.NO_WARNING ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "2.34521",
    y: "9.99927",
    width: "11.25",
    height: "11.25",
    transform: "rotate(-45 2.34521 9.99927)",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4145 9.52855L10.7715 2.88557C10.5112 2.62522 10.0891 2.62522 9.82872 2.88557L3.18574 9.52855C2.92539 9.7889 2.92539 10.211 3.18574 10.4714L9.82872 17.1143C10.0891 17.3747 10.5112 17.3747 10.7715 17.1143L17.4145 10.4714C17.6748 10.211 17.6748 9.78889 17.4145 9.52855ZM11.4786 2.17846C10.8278 1.52759 9.77248 1.52759 9.12161 2.17846L2.47863 8.82144C1.82776 9.47231 1.82776 10.5276 2.47863 11.1785L9.12161 17.8214C9.77248 18.4723 10.8278 18.4723 11.4786 17.8214L18.1216 11.1785C18.7725 10.5276 18.7725 9.47231 18.1216 8.82144L11.4786 2.17846Z",
    fill: color
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6.31519",
    y: "10.2258",
    width: "1.2",
    height: "4.46314",
    rx: "0.6",
    transform: "rotate(-45 6.31519 10.2258)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "13.4363",
    y: "7.80005",
    width: "1.2",
    height: "6.69472",
    rx: "0.6",
    transform: "rotate(45 13.4363 7.80005)",
    fill: "white"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "2.04517",
    y: "10.3788",
    width: "11.25",
    height: "11.25",
    transform: "rotate(-45 2.04517 10.3788)",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1145 9.90806L10.4715 3.26509C10.2111 3.00474 9.78902 3.00474 9.52867 3.26509L2.88569 9.90806C2.62534 10.1684 2.62534 10.5905 2.88569 10.8509L9.52867 17.4938C9.78902 17.7542 10.2111 17.7542 10.4715 17.4938L17.1145 10.8509C17.3748 10.5905 17.3748 10.1684 17.1145 9.90806ZM11.1786 2.55798C10.5277 1.90711 9.47243 1.90711 8.82156 2.55798L2.17859 9.20096C1.52771 9.85183 1.52771 10.9071 2.17859 11.558L8.82156 18.2009C9.47244 18.8518 10.5277 18.8518 11.1786 18.2009L17.8216 11.558C18.4724 10.9071 18.4724 9.85183 17.8216 9.20095L11.1786 2.55798Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90001 5.87842C10.2314 5.87842 10.5 6.16624 10.5 6.52128V10.807C10.5 11.162 10.2314 11.4498 9.90001 11.4498C9.56864 11.4498 9.30001 11.162 9.30001 10.807V6.52128C9.30001 6.16624 9.56864 5.87842 9.90001 5.87842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 13.9141C10.8 14.4467 10.3971 14.8784 9.9 14.8784C9.40294 14.8784 9 14.4467 9 13.9141C9 13.3816 9.40294 12.9498 9.9 12.9498C10.3971 12.9498 10.8 13.3816 10.8 13.9141Z",
    fill: "white"
  })));
};

WarningIcon.propTypes = _objectSpread2({
  variant: PropTypes.oneOf(Object.values(VARIANT))
}, iconPropTypes);
WarningIcon.defaultProps = _objectSpread2({
  variant: VARIANT.DANGER
}, iconDefaultProps);
WarningIcon.VARIANT = VARIANT;

var TimeRegistrationIcon = function TimeRegistrationIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.8C14.8601 18.8 18.8 14.8601 18.8 10C18.8 5.13989 14.8601 1.2 10 1.2C5.13989 1.2 1.2 5.13989 1.2 10C1.2 14.8601 5.13989 18.8 10 18.8ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.11875C10.3314 6.11875 10.6 6.38738 10.6 6.71875V10C10.6 10.3314 10.3314 10.6 10 10.6C9.66863 10.6 9.4 10.3314 9.4 10V6.71875C9.4 6.38738 9.66863 6.11875 10 6.11875Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57578 9.57569C9.81012 9.3414 10.19 9.34144 10.4243 9.57578L14.5254 13.6778C14.7597 13.9121 14.7597 14.292 14.5253 14.5263C14.291 14.7606 13.9111 14.7606 13.6768 14.5262L9.57569 10.4242C9.3414 10.1899 9.34144 9.80998 9.57578 9.57569Z",
    fill: "#4C4C58"
  })));
};

TimeRegistrationIcon.propTypes = iconPropTypes;
TimeRegistrationIcon.defaultProps = iconDefaultProps;

var ProgressRegistrationIcon = function ProgressRegistrationIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C9.64734 0 9.29874 0.0182791 8.95514 0.0539789C8.62554 0.0882236 8.38611 0.383175 8.42036 0.712772C8.4546 1.04237 8.74955 1.2818 9.07915 1.24755C9.38163 1.21613 9.68883 1.2 10 1.2C14.8601 1.2 18.8 5.13989 18.8 10C18.8 14.8601 14.8601 18.8 10 18.8C9.68883 18.8 9.38163 18.7839 9.07915 18.7524C8.74955 18.7182 8.4546 18.9576 8.42036 19.2872C8.38611 19.6168 8.62554 19.9118 8.95514 19.946C9.29874 19.9817 9.64734 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41999 1.95856C6.72263 1.82361 6.85857 1.46886 6.72362 1.16622C6.58867 0.863574 6.23392 0.727633 5.93128 0.862586C5.28928 1.14886 4.68317 1.50071 4.12144 1.90952C3.85352 2.10451 3.79439 2.47978 3.98938 2.74771C4.18437 3.01564 4.55964 3.07476 4.82757 2.87977C5.32212 2.51985 5.85544 2.2103 6.41999 1.95856Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87977 4.82757C3.07476 4.55964 3.01564 4.18437 2.74771 3.98938C2.47978 3.79439 2.10451 3.85351 1.90952 4.12144C1.50071 4.68317 1.14886 5.28928 0.862587 5.93128C0.727633 6.23392 0.863575 6.58867 1.16622 6.72362C1.46887 6.85857 1.82361 6.72263 1.95856 6.41999C2.2103 5.85544 2.51985 5.32212 2.87977 4.82757Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24755 9.07915C1.2818 8.74955 1.04237 8.4546 0.712772 8.42036C0.383175 8.38611 0.0882236 8.62554 0.0539789 8.95514C0.0182791 9.29874 0 9.64734 0 10C0 10.3527 0.0182791 10.7013 0.0539789 11.0449C0.0882236 11.3745 0.383175 11.6139 0.712772 11.5796C1.04237 11.5454 1.2818 11.2504 1.24755 10.9208C1.21613 10.6184 1.2 10.3112 1.2 10C1.2 9.68883 1.21613 9.38163 1.24755 9.07915Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95856 13.58C1.82361 13.2774 1.46886 13.1414 1.16622 13.2764C0.863574 13.4113 0.727633 13.7661 0.862586 14.0687C1.14886 14.7107 1.50071 15.3168 1.90952 15.8786C2.10451 16.1465 2.47978 16.2056 2.74771 16.0106C3.01564 15.8156 3.07476 15.4404 2.87977 15.1724C2.51985 14.6779 2.2103 14.1446 1.95856 13.58Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82757 17.1202C4.55964 16.9252 4.18437 16.9844 3.98938 17.2523C3.79439 17.5202 3.85351 17.8955 4.12144 18.0905C4.68317 18.4993 5.28928 18.8511 5.93128 19.1374C6.23392 19.2724 6.58867 19.1364 6.72362 18.8338C6.85857 18.5311 6.72263 18.1764 6.41999 18.0414C5.85544 17.7897 5.32212 17.4802 4.82757 17.1202Z",
    fill: "#4C4C58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07575 10.5757C5.31007 10.3414 5.68997 10.3414 5.92428 10.5757L8.00003 12.6515L14.0758 6.57576C14.3101 6.34145 14.69 6.34145 14.9243 6.57576C15.1586 6.81007 15.1586 7.18997 14.9243 7.42429L8.42429 13.9243C8.18997 14.1586 7.81007 14.1586 7.57576 13.9243L7.57308 13.9216L5.07575 11.4243C4.84144 11.1899 4.84144 10.8101 5.07575 10.5757Z",
    fill: "#4C4C58"
  })));
};

ProgressRegistrationIcon.propTypes = iconPropTypes;
ProgressRegistrationIcon.defaultProps = iconDefaultProps;
exports.AdminIcon = AdminIcon;
exports.ClientIcon = ClientIcon;
exports.ConnectedProjectIcon = ConnectedProjectIcon;
exports.ExpenseIcon = ExpenseIcon;
exports.HelpIcon = HelpIcon;
exports.KeyboardIcon = KeyboardIcon;
exports.LogOffIcon = LogOffIcon;
exports.PrintIcon = PrintIcon;
exports.ProfileIcon = ProfileIcon;
exports.ProgressRegistrationIcon = ProgressRegistrationIcon;
exports.ProjectIcon = ProjectIcon;
exports.ReportIcon = ReportIcon;
exports.ShareIcon = ShareIcon;
exports.StarIcon = StarIcon;
exports.SubTaskIcon = SubTaskIcon;
exports.TaskIcon = TaskIcon;
exports.TeamMemberIcon = TeamMemberIcon;
exports.TimeEntryIcon = TimeEntryIcon;
exports.TimeRegistrationIcon = TimeRegistrationIcon;
exports.TimerIcon = TimerIcon;
exports.UnlockIcon = UnlockIcon;
exports.WarningIcon = WarningIcon;
exports.WhatIsNewIcon = WhatIsNewIcon;